import React, { createContext, useContext, useState } from "react";

export const TokensContext = createContext();

export default function TokensContextProvider({children}) {
  const [idToken, setIdToken] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  return (<TokensContext.Provider value={{
            idToken,      setIdToken,
            accessToken,  setAccessToken
          }}>
            {children}
          </TokensContext.Provider>);
}

export function useTokensContext() {
  return useContext(TokensContext);
}